import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from '@material-ui/core';


class InformationDialog extends Component {


        render() {

            const { open, handleClose } = this.props
            return (
                <div>
                    
                    <Dialog
                        disableBackdropClick
                        disableEscapeKeyDown
                        open={open}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"SUCCESS"}</DialogTitle>

                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Thank you for contacting us. We have received your enquiry and our sale team will contact to you shortly.
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>

                                <Button onClick={  handleClose } color="primary">
                                    Ok
                                </Button>

                            </DialogActions>

                    </Dialog>

                </div>
            )

        }

}

const styles = theme => ({
    content: {
        display: 'flex',
        minHeight: '10vh',
        justifyContent: 'center'
    }
})

InformationDialog.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(styles)(InformationDialog)